import PhotoSwipeLightbox from 'photoswipe/lightbox';

export default function photoswipe() {
    const lightbox = new PhotoSwipeLightbox({
      gallery: '.m-images_content a',
      showHideAnimationType: 'zoom',
      initialZoomLevel: 'fit',
      showHideAnimationType: 'fade',
      arrowPrev: false,
      arrowNext: false,
      pswpModule: () => import('photoswipe')
    });
    lightbox.init();
}